import { BonusInfo } from './../interface/bonus-info.interface';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

/**
 * @description this message service
 * will be used to communicate between
 * components
 * @date 2018-07-20
 * @export
 * @class CheckoutMessageService
 */
@Injectable()
export class PersonalMessageService {
    
    private submitPersonalInfoForm: Subject<any> = new Subject<any>();
    private rebindPersonalInfoForm: Subject<any> = new Subject<any>();
    private submitBonusInfoForm: Subject<any> = new Subject<any>();
    private vatIdChanged: Subject<boolean> = new Subject<boolean>();
    private rebindBonusinfoForm: Subject<boolean> = new Subject<boolean>();
    private disableBonusInfoForm: Subject<boolean> = new Subject<boolean>();
    private updateBonusInfoForm: Subject<boolean> = new Subject<boolean>();
    private validateIbanInfo: Subject<boolean> = new Subject<boolean>();
    private previousBonusInfo: BonusInfo = null;
    private submitBusinessInfo: Subject<boolean> = new Subject<boolean>(); 
    previousAccountNumber: Subject<BonusInfo> = new Subject<BonusInfo>();

    /**
     * To submit personal infor form
     * @param isFormSubmit 
     */
    setSubmitPersonalinfoForm(isFormSubmit: boolean): void {
        this.submitPersonalInfoForm.next(isFormSubmit);
    }

    getSubmitPersonalInfoForm(): Observable<any> {
        return this.submitPersonalInfoForm.asObservable();
    }

    /**
     * To Rebind Personal Info Form on country Change
     * @param isRebind
     */
    setRebindPersonalinfoForm(isRebind: boolean): void {
        this.rebindPersonalInfoForm.next(isRebind);
    }

    getRebindPersonalInfoForm(): Observable<any> {
        return this.rebindPersonalInfoForm.asObservable();
    }

    /**
     * To Submit the Bonus Form
     * getSubmitBonusInfoForm()
     */
    getSubmitBonusInfoForm(): Observable<any> {
        return this.submitBonusInfoForm.asObservable();
    }

    /**
     * setSubmitBonusInfoForm()
     * @param isSubmit
     */
    setSubmitBonusInfoForm(isSubmit: boolean): void {
        this.submitBonusInfoForm.next(isSubmit);
    }

    /**
     * get vatIdChanged
     */
    getVatIdChanged(): Observable<boolean> {
        return this.vatIdChanged.asObservable();
    }

    /**
     * set vatIdChanged
     */
    setVatIdChanged(vatIdChanged: boolean): void {
        this.vatIdChanged.next(vatIdChanged);
    }

    /**
     * To Rebind Bonus Info Schema Form on Country Change
     * @param isRebind
     */
    setRebindBonusinfoForm(isRebind: boolean){
        this.rebindBonusinfoForm.next(isRebind);
    }

    getRebindBonusinfoForm(){
        return this.rebindBonusinfoForm.asObservable();
    }

    setDisableBonusInfoForm(value:boolean){
        this.disableBonusInfoForm.next(value);
    }

    getDisableBonusInfoForm(){
        return this.disableBonusInfoForm.asObservable();
    }

    setValidBonusInfoForm(value:boolean){
        this.updateBonusInfoForm.next(value);
    }

    getValidBonusInfoForm(){
        return this.updateBonusInfoForm.asObservable();
    }
    setValidateIbanInfo(value:boolean){
        this.validateIbanInfo.next(value);
    }
    getValidateIbanInfo(): Observable<boolean>{
        return this.validateIbanInfo.asObservable();
    }
 

    setPreviousBonusInfo(bonuInfo:BonusInfo){
        this.previousBonusInfo = bonuInfo;
    }

    getPreviousBonusInfo(){
        return this.previousBonusInfo;
    }

    setSubmitBusinessInfo(isSubmit: boolean): void {
        this.submitBusinessInfo.next(isSubmit);
    }

    getSubmitBusinessInfo(): Observable<boolean> {
        return this.submitBusinessInfo.asObservable();
    }

    setPreviousAccountNumber(bonuInfo:BonusInfo){
        this.previousAccountNumber.next(bonuInfo);
    }

    getPreviousAccountNumber():Observable<BonusInfo>{
        return this.previousAccountNumber.asObservable();
    }
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/personal-schema-form.service.ts